import React, {FC, createContext, useContext} from 'react'
import {DEFAULT_APP_LOCALE, isAppLocale} from '../../app/i18n/config'
import {WithChildren} from '../helpers'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

const METRONIC_LANGS = ['de', 'en', 'es', 'fr', 'ja', 'zh'] as const
type MetronicLang = (typeof METRONIC_LANGS)[number]

export type UiLang = MetronicLang | 'id'

type Props = {
  selectedLang: UiLang
}
const initialState: Props = {
  selectedLang: DEFAULT_APP_LOCALE,
}

function isUiLang(value: string): value is UiLang {
  return isAppLocale(value) || (METRONIC_LANGS as readonly string[]).includes(value)
}

function getConfig(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  if (ls) {
    try {
      const parsed = JSON.parse(ls) as Props
      if (parsed?.selectedLang && isUiLang(parsed.selectedLang)) {
        return parsed
      }
    } catch (er) {
      console.error(er)
    }
  }
  return initialState
}

// Side effect
export function setLanguage(lang: string) {
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: lang}))
  window.location.reload()
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

const MetronicI18nProvider: FC<WithChildren> = ({children}) => {
  const lang = getConfig()
  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

export {MetronicI18nProvider, useLang}
